import { render } from "./Dashboard.vue?vue&type=template&id=06087aee&scoped=true&ts=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=06087aee&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06087aee"]])

export default __exports__